import { useLayoutEffect } from 'preact/hooks';
import { teadsApi } from '../../teads-api';

export function useSetAdBackgroundColor(color: string) {
  useLayoutEffect(() => {
    teadsApi.setBackgroundColor(color);
  }, []);
}
